function showTemporaryError(input, message, duration = 2000, id = 'field-temp-error') {
    if (!input) return;
    let msg = document.getElementById(id);
    if (!msg) {
        msg = document.createElement('div');
        msg.id = id;
        msg.style.cssText = `
            color: #dc3545;
            font-size: 12px;
            margin-left: 8px;
            margin-top: 4px;
            display: none;
        `;
        input.parentNode.insertBefore(msg, input.nextSibling);
    }
    msg.textContent = message;
    msg.style.display = 'block';
    clearTimeout(msg._hideTimeout);
    msg._hideTimeout = setTimeout(() => {
        msg.style.display = 'none';
    }, duration);
}

document.addEventListener('keydown', function (event) {
  if (event.target && event.target.id === 'cnpj-input-change-org' && event.key === 'Enter') {
    event.preventDefault();
    loadOrganizationDataTelesales();
  }
});

let isLoadingOrganizationData = false;
let telesalesOrganizationSelectionState = null;

function formatCompanyDocument(value) {
  if (!value) return '';
  return String(value).replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
}

function formatLocationAddress(location) {
  const address = location?.shippingAddress || location?.billingAddress || {};
  const parts = [
    address.address1,
    address.city,
    address.zoneCode || address.state || address.provinceCode,
  ].filter(Boolean);
  return parts.length ? parts.join(' / ') : 'Endereço não informado';
}

function getArrowDownIconSrc() {
  return document.getElementById('arrow-down')?.src || '';
}

function renderOrganizationWithLocationsData(payload, container) {
  const organization = payload?.organization;
  const locations = Array.isArray(payload?.locations)
    ? payload.locations.filter((location) => location?.isActive === true)
    : [];

  if (!organization) {
    container.innerHTML = `
      <div class="dados">
        <span>Empresa não encontrada para o CNPJ informado.</span>
      </div>
    `;
    return;
  }

  telesalesOrganizationSelectionState = {
    organization,
    locations,
    selectedLocationId: locations[0]?.id ? String(locations[0].id) : null,
    locationsExpanded: true,
  };

  const locationsContent = locations.length
    ? locations.map((location, index) => `
        <button
          type="button"
          class="location-selection-item ${index === 0 ? 'selected' : ''}"
          data-location-id="${location.id}"
          onclick="selectTelesalesLocation('${location.id}')"
        >
          <div class="location-selection-item-main">
            <strong>${location.name || 'Local sem nome'}</strong>
            <span>${formatLocationAddress(location)}</span>
          </div>
          <span class="location-selection-item-radio" aria-hidden="true"></span>
        </button>
        ${index < locations.length - 1 ? '<div class="location-selection-divider" aria-hidden="true"></div>' : ''}
      `).join('')
    : `<div class="location-selection-empty">Nenhum local disponível para essa empresa.</div>`;

  container.innerHTML = `
    <div class="dados dados-filial telesales-org-card" id="telesales-org-selection">
      <div class="filial-info telesales-org-header" role="button" tabindex="0" onclick="toggleTelesalesLocations()" onkeydown="if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggleTelesalesLocations(); }">
        <p>${organization.companyName || 'Empresa sem nome'}</p>
        <span>${formatCompanyDocument(organization.document)}</span>
        <span>${organization?.billingAddress?.city || ''} / ${organization?.billingAddress?.state || ''}</span>
      </div>
      <div class="telesales-org-arrow" aria-hidden="true" onclick="toggleTelesalesLocations()">
        <img src="${getArrowDownIconSrc()}" alt="" class="telesales-org-arrow-icon is-open" />
      </div>
    </div>
    <div id="telesales-locations-container" class="location-selection-list telesales-locations-container" style="display:flex;">
      ${locationsContent}
    </div>
    <button type="button" class="custom-main-btn" style="margin-top:8px;" onclick="submitTelesalesOrganizationChange(this)" ${locations.length === 0 ? 'disabled' : ''}>
      Trocar empresa
    </button>
  `;
}

function toggleTelesalesLocations() {
  if (!telesalesOrganizationSelectionState) return;

  telesalesOrganizationSelectionState.locationsExpanded = !telesalesOrganizationSelectionState.locationsExpanded;
  const locationsContainer = document.getElementById('telesales-locations-container');
  const arrowIcon = document.querySelector('.telesales-org-arrow-icon');

  if (locationsContainer) {
    locationsContainer.style.display = telesalesOrganizationSelectionState.locationsExpanded ? 'flex' : 'none';
  }

  if (arrowIcon) {
    arrowIcon.classList.toggle('is-open', telesalesOrganizationSelectionState.locationsExpanded);
  }
}

function selectTelesalesLocation(locationId) {
  if (!telesalesOrganizationSelectionState) return;

  telesalesOrganizationSelectionState.selectedLocationId = String(locationId);
  document.querySelectorAll('#telesales-locations-container .location-selection-item').forEach((item) => {
    item.classList.toggle('selected', String(item.dataset.locationId) === String(locationId));
  });
}

async function submitTelesalesOrganizationChange(triggerButton) {
  if (!telesalesOrganizationSelectionState?.organization?.organizationId) return;

  await changeOrganization(
    telesalesOrganizationSelectionState.organization.organizationId,
    null,
    null,
    telesalesOrganizationSelectionState.selectedLocationId,
    triggerButton
  );
}

async function loadOrganizationDataTelesales() {
  if (isLoadingOrganizationData) return;

  const searchBtn = document.querySelector('.filial-form .input-search-btn');
  const filiaisContainer = document.querySelector("#filiais-container");
  filiaisContainer.innerHTML = "";
  const input = document.getElementById('cnpj-input-change-org');
  const cnpjR = unmaskCNPJ(input.value);

  if (!cnpjR || cnpjR === '') {
    showTemporaryError(input, 'O campo CNPJ é obrigatório', 3000, 'cnpj-empty-error');
    return;
  }

  if (cnpjR.length < 8) {
    showTemporaryError(input, 'CNPJ inválido. Deve pelo menos 8 dígitos.', 3000, 'cnpj-invalid-error');
    return;
  }

  isLoadingOrganizationData = true;
  if (searchBtn) searchBtn.disabled = true;
  showMyAccountSpinner(filiaisContainer);

  try {
    const responsePayload = await getOrganizationByCnpjWithLocations(globalCustomerId, cnpjR);

    if (!responsePayload?.organization) {
        filiaisContainer.innerHTML = `
            <div class="dados">
                <span>Nenhuma empresa encontrada com esse CNPJ.</span>
            </div>
        `;
        removeMyAccountSpinner(filiaisContainer);
        return;
    }

    renderOrganizationWithLocationsData(responsePayload, filiaisContainer);
  } catch (error) {
    filiaisContainer.innerHTML = `
        <div class="dados">
          <span>Ocorreu um erro ao buscar a empresa com esse CNPJ.</span>
        </div>
      `;
  } finally {
    removeMyAccountSpinner(filiaisContainer);
    isLoadingOrganizationData = false;
    if (searchBtn) searchBtn.disabled = false;
  }
}

const observer = new MutationObserver(function(mutations) {
    const elemento = document.getElementById('cnpj-input-change-org');
    if (elemento) {
        MaskCNPJ(elemento);
        observer.disconnect();
    }
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

function MaskCNPJ(input) {
    input.addEventListener('input', function (e) {
        const valorOriginal = e.target.value;
        let valor = valorOriginal.replace(/[^A-Z\d]/gi, '').toUpperCase();

        valor = valor.substring(0, 12) + valor.substring(12).replace(/[A-Z]/i, '');

        valor = valor.substring(0, 14);
        valor = valor.replace(/^([0-9A-Z]{2})([0-9A-Z])/, '$1.$2');
        valor = valor.replace(/^([0-9A-Z]{2})\.([0-9A-Z]{3})([0-9A-Z])/, '$1.$2.$3');
        valor = valor.replace(/\.([0-9A-Z]{3})([0-9A-Z])/, '.$1/$2');
        valor = valor.replace(/([0-9A-Z]{4})(\d)/, '$1-$2');

        e.target.value = valor;
    });
}

function unmaskCNPJ(value) {
    if (!value) return '';
    return value.toString().replace(/[^A-Z\d]/gi, '').slice(0, 14);
}